var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"loading-animation",staticStyle:{"color":"#000"}},[_vm._v("Loading...")]):_vm._e(),(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }